export type GCColor =
  | "black"
  | "coolGrey"
  | "gcBlue"
  | "gc-blue"
  | "orange"
  | "gcGreen"
  | "dark-green"
  | "coolGreyDark"
  | "red"
  | "green"
  | "offBlack"
  | "white";

export const IconSizes = {
  // consult with design before adding new sizes
  large: 48,
  medium: 32,
  small: 24,
  xsmall: 16,
};

export type IconSize = keyof typeof IconSizes;

export interface IconProps {
  fill?: GCColor;
  stroke?: GCColor;
  size?: IconSize;
}
